import { Component } from '@angular/core';
import { Notification } from '../core/servises/notifications/models/notification.interface';
import { NotificationsService } from '../core/servises/notifications/notifications.service';

@Component({
    selector: 'aft-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false,
})
export class NotificationsComponent {
  constructor(
    private _notificationsService: NotificationsService,
  ) {}

  get notifications(): Notification[] {
    return this._notificationsService.visibleNotifications();
  }

  protected notificationClosed(createdAt: Date): void {
    this._notificationsService.removeNotification(createdAt.getTime());
  }

  protected removeAllNotifications(): void {
    this._notificationsService.removeAllNotifications();
  }
}
